function getUserOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "unknown";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

const customerAreaModel = {
  attachListeners: function () {
    this.modalCustomerAreaOpen();
    this.modalCustomerAreaClose();
    this.modalFooterClose();
  },

  init: function () {
    document.addEventListener("DOMContentLoaded", () => {
      this.attachListeners();
    });
  },

  modalCustomerAreaOpen: function () {
    $(".js-btn-customer-area").on("click", function () {
      $(".js-modal-customer-area, #overlay-custom-modal, #modal-custom")
        .removeClass("d-none")
        .addClass("d-block is-visible");
      // Check if emergency modal exist
      if (
        document.getElementById("close-btn") &&
        document.getElementById("overlay-custom-modal")
      ) {
        $("body").css("overflow-y", "hidden");
      }

      if ($(window).width() < 899) {
        let os = getUserOperatingSystem();
        if (os == "Android") {
          $(".js-modal-footer #android-app-btn")
            .removeClass("d-none")
            .addClass("d-block-inline");
        } else if (os == "iOS") {
          $(".js-modal-footer #ios-app-btn")
            .removeClass("d-none")
            .addClass("d-block-inline");
        } else {
          $(".js-modal-footer #other-app-btn")
            .removeClass("d-none")
            .addClass("d-block-inline");
          if (
            document.getElementById("other-app-btn")
          ) {
            $("#other-app-btn").click(function () {
              $("#other-device").removeClass("d-none").addClass("d-block");
            });
          }
        }
        if ($(".js-modal-footer").hasClass("d-none")) {
          $(".js-modal-footer").addClass("d-block").removeClass("d-none");
        }
      }
    });
  },
  modalCustomerAreaClose: function () {
    $(".js-btn-customer-area-modal").on("click", function () {
      $(".js-modal-customer-area").removeClass("d-block").addClass("d-none");
    });
  },
  modalFooterClose: function () {
    $(".js-btn-access-app").on("click", function () {
      $(".js-modal-footer").addClass("d-none");
      $(".js-modal-body")
        .addClass("modal-footer-disactive")
        .removeClass("modal-footer-active");
    });
  },
};

window.customerAreaModel = customerAreaModel;
window.customerAreaModel.init();
